import { QueryConfig } from "store/utils/query-config";

export const newsFeedItemsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["-createdAt"],
  },
};
